module.exports = __webpack_public_path__ + "static/media/photogs and single girl in dress .11dfa7a6.jpg";